var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_77362)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FA532E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3335 11.4282C9.3335 10.2711 10.2716 9.33301 11.4287 9.33301H17.524C18.6811 9.33301 19.6192 10.2711 19.6192 11.4282V12.3806H20.5716C21.7288 12.3806 22.6668 13.3187 22.6668 14.4759V20.5711C22.6668 21.7283 21.7288 22.6663 20.5716 22.6663H14.4764C13.3192 22.6663 12.3811 21.7283 12.3811 20.5711V19.6187H11.4287C10.2716 19.6187 9.3335 18.6807 9.3335 17.5235V11.4282ZM13.524 20.5711C13.524 21.0971 13.9504 21.5235 14.4764 21.5235H20.5716C21.0976 21.5235 21.524 21.0971 21.524 20.5711V14.4759C21.524 13.9499 21.0976 13.5235 20.5716 13.5235H14.4764C13.9504 13.5235 13.524 13.9499 13.524 14.4759V20.5711ZM18.4764 12.3806H14.4764C13.3192 12.3806 12.3811 13.3187 12.3811 14.4759V18.4759H11.4287C10.9027 18.4759 10.4764 18.0495 10.4764 17.5235V11.4282C10.4764 10.9023 10.9027 10.4759 11.4287 10.4759H17.524C18.05 10.4759 18.4764 10.9023 18.4764 11.4282V12.3806Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_77362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCopy);
export default __webpack_public_path__ + "static/media/orange-copy.43016362121207cff6413dbd93ebccc7.svg";
export { ForwardRef as ReactComponent };